import request from '../../setup/axios/request'

const lang = localStorage.getItem('i18nConfig')
const lang_r = lang ? JSON.parse(lang).selectedLang : 'VI'

export const getListCategory = (type: string, bussiness?: string) => {
  return request({
    url: '/api/v1/SellingStep/get-list-category?type=' + type + '&businessProgram=' + bussiness,
    method: 'get',
  })
}

export const getListAgency = (type: string, agency?: string) => {
  return request({
    url: '/api/v1/SellingStep/get-list-category?type=' + type + '&agency=' + agency,
    method: 'get',
  })
}

export const getJsonLabelMultiLanguage = (languageCode: string, applicationType?: string) => {
  return request({
    url:
      'api/v1/Selling/MultiLanguge/get-json-label-multi-language?languageCode=' +
      languageCode +
      '&applicationType=' +
      applicationType,
    method: 'get',
  })
}

export const dataDivisionsForLogin = (data: any) => {
  return request({
    url: '/api/v1/Selling/data-divisions-for-login',
    method: 'post',
    data: data,
  })
}

export const creatOrUpdateMultiLanguageApplication = (data: any) => {
  return request({
    url: 'api/v1/Configuration/MultiLanguge/create-or-update-multi-language-application',
    method: 'post',
    data: data,
  })
}

export const getListValueOfKey = (languageCode: string, applicationType?: string) => {
  return request({
    url:
      'api/v1/Selling/MultiLanguge/get-list-value-of-key?key=' +
      languageCode +
      '&applicationType=' +
      applicationType,
    method: 'get',
  })
}

export const getListProduct = () => {
  let dataFilter = {
    filter: {
      searchField: '',
      code: '',
      name: '',
      languageCode: lang_r.toUpperCase(),
    },
    orderBy: [
      {
        fieldName: '',
        direction: 0,
      },
    ],
    languageCode: lang_r.toUpperCase(),
    pageIndex: 0,
    pageSize: -1,
    showTotal: true,
  }
  return request({
    url: 'api/v1/Selling/insuranceProduct/search-and-pagging',
    method: 'post',
    data: dataFilter,
  })
}
